
import $ from "jquery";
import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { Grid, Input, Button, Pagination, TextArea, Form, Icon, Table, Radio } from 'semantic-ui-react';

import View from './view';
import Loading from '../../loadings';
import SalesType from './salestype';
import Tax from '../../PurchaseAndStock/PurchaseDetails/taxs';
import Server from '../../../functions/server';
import Editplaceorder from './editplaceorder';
import '../../PurchaseAndStock/PurchaseDetails/purchasedetails.css';
import CancelledInvoice from './cancelledinvoice';
import ReadCookie from '../../../functions/readcookies';
import Permission from '../../../functions/permission';
import CustomerDetails from '../../others/customerdetails';
import DeliveryDetails from './deliveryDetails';
import AssignBranch from './assigntoAnotherBranch'; 
import DmsValue from './dmsvalues';
import MakeDecimalPoint from '../../makedecimalpoints';

class Customer extends React.Component {

  state = {
    quotationDetails: [], openView: false, viewTaxSystem: false, maxWidth: 'lg', maxWidth1: 'sm', fullWidth: true, quotationDetails: [],
    redeempoints: 0, pageNumber: 0, totalPages: 0, boundaryRange: 1, siblingRange: 1, showEllipsis: true, showFirstAndLastNav: true,
    showPreviousAndNextNav: true, orderDetails: [], search: '', reason: '', viewCancelledInvoice: false, value: 'Approved'
  }

  componentDidMount() {
    this.getDate();
  }

  getDate() {
    let branchId;
    let data = (ReadCookie("branch"));
    if (data == 0) {
      this.setState({ permissionError: 'You not have permission to access this menu!!!' })
    }
    else {
      for (var i = 0; i < data.length; i++) {
        branchId = data[i].branch_id;
      }
      this.setState({ selectedBranch: branchId })
    }
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if(dd < 10) {
      dd = '0' + dd;
    }
    if(mm < 10){
        mm = '0' + mm;
    }
    today = yyyy+'-'+mm+'-'+dd;
    let firstDay = yyyy+'-'+mm+'-01';
    this.setState({ from_date: firstDay, to_date: today })
    this.getQuotation(1, firstDay, today, branchId)
  }

  handlePaginationChange = (e, { activePage }) => {
    this.setState({ pageNumber: activePage });
    this.getQuotation(activePage, this.state.from_date, this.state.to_date, this.state.selectedBranch);
  }

  getQuotation1() {
    this.getQuotation(1, this.state.from_date, this.state.to_date, this.state.selectedBranch)
  }

  getBranch() {
    let data = (ReadCookie("branch"));
    if (data == 0) {
      this.setState({ permissionError: 'You not have permission to access this menu!!!' })
    }
    else {
      let branchId;
      for (var i = 0; i < data.length; i++) {
        branchId = data[i].branch_id;
      }
      this.setState({ selectedBranch: branchId })
    }
  }

  makeDecimalPoints(value) {
    try {
      value = value.toFixed(2);
    } catch (e) {
      value = 0;
    }
    return value;
  }

  convertIntoNumber(value) {
    value = this.makeDecimalPoints(value);
    try {
      value = Number(value);
    } catch (e) {
      value = 0;
    }
    return value;
  }

  convertIntoNumbers(value) {
    try {
      value = Number(value);
    } catch (e) {
      value = 0;
    }
    return value;
  }

  getQuotation(page, fromDate, toDate, branchId) {
    fromDate = fromDate+" 00:00:00";
    toDate = toDate+" 23:59:59";
    let context = this;
    let customer = 0;
    let type = this.props.type;
    let search = this.state.search;
    let cook = (ReadCookie("vaigai"));
    let userId = cook.id;
    let data1 = [];
    data1 = { 'type': this.props.type, 'userId': userId, 'page': page, 'fromDate': fromDate, 'toDate': toDate, 'branchId': branchId, 'search': search };
    context.setState({ load: true, message: 'Getting details!!!' });
    $.ajax({
      type: 'POST', data: data1, url: Server() + 'quotation/getall.php',
      success: function(data) {
        console.log(data);
        let datas = [];
        try {
          data = JSON.parse(data);
          let totalPages = 0; let availablepoints = 0; let amount = 0;
          data.map((c) => { datas = c.data; totalPages = c.total_records; amount = c.amount; })
          totalPages = context.convertIntoNumber(totalPages);
          if (!datas.length) { datas = []; }
          context.setState({ quotationDetails: datas, availablepoints, pageNumber: page, totalPages, load: false, amount })
        } catch (e) {
          context.setState({ load: false });
        }
      },
      error: function(err)
      {
        alert('Try Again!!!')
        context.setState({ load: false })
      }
    })
  }

  handleClose() {
    this.setState({ openView: false, viewTaxSystem: false, voucher: false, invoicePoint: false })
  }

  search() {
    this.getQuotation(1, this.state.from_date, this.state.to_date, this.state.selectedBranch);
  }

  handleChange = name => event => {
    if (name == 'points') {
      if (event.target.value < 0) {
        document.getElementById("points").value = "";
        alert('No Nagetive Points!!!');
        return;
      }
    }
    if (name == 'redeempoints') {
      if (event.target.value < 0) {
        document.getElementById("redeempoints").value = "";
        alert('No Nagetive Points!!!');
        return;
      }
    }
    this.setState({
      [name]: event.target.value,
    });
  };

  viewTax(id, total) {
    let context =this;
    this.setState({ load: true, message: 'Getting Tax!!!!' });
    let data1 = { 'id': id };
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'placeorder/gettax.php',
      success: function(data)
      {
        context.setState({ load: false })
        try {
          data = JSON.parse(data);
          context.setState({ taxs: data, totalPrices: total, viewTaxSystem: true })
        } catch (e) {
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }

  generateInvoice() {
    let context = this;
    if (this.state.points == '' || this.state.points == null || this.state.points == undefined) {
      alert('Enter Reward Points');
      return;
    }
    let menuControl = this.props.menus;
    let redeempoints = "-"+this.state.redeempoints;
    redeempoints = Number(redeempoints);
    let data1 = { 'id': this.state.InvoiceId, 'value': 'I'+this.state.InvoiceId,
                  'redeempoints': redeempoints,
                  'invoiceCustomerId': this.state.invoiceCustomerId, 'points': this.state.points };
    context.setState({ load: true, message: 'Generating invoice!!!' })
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'quotation/genrateinvoice.php',
      success: function(data)
      {
        context.setState({ load: false, invoicePoint: false })
        if (data == 1) {
          let items = [];
          context.state.quotationDetails.map((z) =>{
            if (context.state.InvoiceId == z.id) {
            }
            else {
              items.push(z);
            }
          });
          context.setState({ quotationDetails: items })
        }
      },
      error: function(err)
      {
        alert('Try Again!!!')
        context.setState({ load: false })
      }
    })
  }

  deleteInvoice() {
    let cook = (ReadCookie("vaigai"));
    let userId = cook.id;
    let id = this.state.deleteid;
    let invoiceid = this.state.deleteinvoiceid;
    let quotationid =  this.state.deletequotationid;
    let remark =  this.state.remark;
    let invoicevoucher = this.state.invoicevoucher
    let context = this;
    let data1 = [];
    let server;
    if (this.props.type == 'invoice') {
      data1 = { 'id': quotationid, 'status': this.state.value };
      server = Server()+'quotation/cancelquotation.php';
    }
    else {
      if (!remark) {
        alert('Enter the Remarks!!!');
        return;
      }
      data1 = { 'id': invoiceid, 'mid': id, 'quotationid': quotationid, 'branch': this.state.selectedBranch,
        'remark': remark, 'invoicevoucher': invoicevoucher, 'executiveid': userId };
      server = Server()+'quotation/cancelinvoice.php';
    }
    this.setState({ load: true, message: 'Cancelling!!!' })
    $.ajax({
      type: 'POST',
      data: data1,
      url: server,
      success: function(data) {
        console.log(data);
        context.setState({ load: false })
        if (context.props.type == 'invoice') {
          if (data == 1) {
            let items = [];
            context.state.quotationDetails.map((z) => {
              if (quotationid != z.id) {
                items.push(z);
              }
            })
            context.setState({ quotationDetails: items, open: false })
          }
        }
        else {
          let item = [];
          context.state.quotationDetails.map((z) =>{
            if (invoiceid != z.invoice) {
              item.push(z);
            }
          })
          context.setState({ quotationDetails: item, open: false })
        }
      },
      error: function(err)
      {
        alert('Try Again!!!')
        context.setState({ load: false })
      }
    })
  }

  cancel(id, invoiceid, quotationid, invoicevoucher, creditstocks) {
    if (!this.props.menuPermission.cancel) {
      alert('You are not allow to cancel!!!');
      return;
    }
    creditstocks = this.convertIntoNumbers(creditstocks);
    if (creditstocks > 0) {
      alert('Some Stock in Credit Note Please Clear And Cancel Invoice!!!');
    }
    else {
      this.setState({ deleteid: id, deleteinvoiceid: invoiceid,
        deletequotationid: quotationid, open: true, invoicevoucher })
    }
  }

  submit() {
    let context = this;
    let voucherId = this.state.voucherId;
    let voucherValue = this.state.voucherValue;
    let data1 = { 'voucherId': voucherId, 'voucherValue': voucherValue }
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'quotation/updatevoucher.php',
      success: function(data)
      {
        if (data == 1) {
          let quotationDetails = context.state.quotationDetails;
          quotationDetails.map((z) => {
            if (z.id == voucherId) {
              z.voucher = voucherValue;
            }
          });
          context.setState({ voucher: false, quotationDetails: quotationDetails })
        }
      },
      error: function(err)
      {

      }
    })
  }

  export() {
    if (!this.props.menuPermission.exports) {
      alert('You Are Not Allow To Export!!!');
      return;
    }
    if (this.state.from_date == undefined || this.state.from_date == '') {
      alert('Enter the From date!!!');
      return;
    }
    if (this.state.to_date == undefined || this.state.to_date == '') {
      alert('Enter the To date!!!');
      return;
    }
    let fromDate = this.state.from_date;
    let toDate = this.state.to_date;
    let search = this.state.search;
    let branch = this.state.selectedBranch;
    window.location = Server() + 'quotation/export.php?fromdate='+fromDate+'&todate='+toDate+'&branch='+branch;
  }

  exportinvoice() {
    if (!this.props.menuPermission.exports) {
      alert('You Are Not Allow To Export!!!');
      return;
    }
    if (this.state.from_date == undefined || this.state.from_date == '') {
      alert('Enter the From date!!!');
      return;
    }
    if (this.state.to_date == undefined || this.state.to_date == '') {
      alert('Enter the To date!!!');
      return;
    }
    let fromDate = this.state.from_date;
    let toDate = this.state.to_date;
    let branch = this.state.selectedBranch;
    window.location = Server() + 'invoice/export.php?fromdate='+fromDate+'&todate='+toDate+'&branch='+branch;

  }

  generateInvoices(id, invoiceCustomerId) {
    let context = this;
    $.ajax({
      type: 'POST',
      data: { 'id': id },
      url: Server() + 'quotation/getorder.php',
      success: function(data)
      {
        try {
          data = JSON.parse(data);
          for (var i = 0; i < data.length; i++) {
            let s = 1;
            data[i].sino = s + i;
            data[i].id = data[i].partnumber;
          }
        } catch (e) {
          console.log(e);
        }
      },
      error: function(err)
      {
        alert('Try Again!!!')
        context.setState({ load: false })
      }
    })
    this.setState({ InvoiceId: id, invoicePoint: true, invoiceCustomerId: invoiceCustomerId })
  }

  getOrderDetails1(id) {
    let data = this.state.quotationDetails;
    data.map((z) => {
      if (id == z.id) {
        this.setState({
          branchId: z.branchId,
          execeptedDate: z.execeptedDate,
          masterId: z.masterId,
          viewId: id
        })
      }
    })
    this.getOrderDetails(id);
  }

  getOrderDetails(id) {
    let context = this;
    let data1 = { 'id': id };
    context.setState({ load: true, message: 'Getting Order details!!!' });
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'quotation/getorder.php',
      success: function(data)
      {
        context.setState({ load: false });
        try {
          data = JSON.parse(data);
          for (var i = 0; i < data.length; i++) {
            let s = 1;
            data[i].sino = s + i;
            data[i].id = data[i].partnumber;
          }
          context.setState({ orderDetails: data, openView: true })
        } catch (e) {
          context.setState({ load: false });
        }
      },
      error: function(err)
      {
        alert('Try Again!!!')
        context.setState({ load: false })
      }
    })
  }

  handleChange22(value) { this.setState({ value: value }) }

  calculateTotalPrice() {

    let quotationDetails = this.state.quotationDetails;
    let total = 0;
    quotationDetails.map((c) => {
      let totalprice = c.totalprice;
      totalprice = Number(totalprice);
      total = total + totalprice;
    })
    total = this.makeDecimalPoint(total, 0);
    return total;
  }

  makeDecimalPoint(value, point) {
    try {
      value = value.toFixed(point);
    } catch (e) {
      value = 0;
    }
    return value;
  }

  diffValue(value1, value2) {
    value1 = this.convertIntoNumbers(value1);
    value2 = this.convertIntoNumbers(value2);
    return value1 - value2;
  }

  downloadJson = (id) => {
    window.location = "https://vaigaiclaas.com/api/v1/web/Accountings/JsonReport/getinvoice.php?id="+id;
  }

  render() {
    let totals = 1.00;
    let i = 1;
    return (
      <div style={{display: this.props.viewcontrol}}>
        <DeliveryDetails menuPermission={this.props.menuPermission} closeDeliveryDialog={ () => { this.setState({ openDeliveryDialog: false }) }} deliveryMasterId={this.state.deliveryMasterId} openDeliveryDialog={this.state.openDeliveryDialog} />
        <Dialog fullWidth={this.state.fullWidth}
          maxWidth={this.state.maxWidth1}  open={this.state.open}
          onClose={ () => { this.setState({ open: false }) } } aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">Conform</DialogTitle>
          <DialogContent>
            Do You Want to Cancel!!!<br/><br/>
            <div style={{display: this.props.display}}>
              <Radio label='Move To Approval Order' name='radioGroup' value='this' checked={this.state.value === 'Approved'} onChange={this.handleChange22.bind(this, 'Approved')} />
              <Radio label='Move To Prior Order' name='radioGroup' value='that' checked={this.state.value === 'Prior Order'} style={{marginLeft: 20}} onChange={this.handleChange22.bind(this, 'Prior Order')} />
            </div>
            <div style={{display: this.props.display1}}>
              <b>Remarks</b>
              <Form>
                <TextArea value={this.state.remark} onChange={this.handleChange('remark')} fluid />
              </Form>
            </div>
          </DialogContent>
          <DialogActions>
            <Button color='blue' onClick={ () => { this.setState({ open: false }) } }>Close</Button>
            <Button color='blue' onClick={this.deleteInvoice.bind(this)}>Submit</Button>
          </DialogActions>
        </Dialog>
        <Loading load={this.state.load} message={this.state.message} />
        <div style={{display: 'flex'}}>

          <div>
            <b>From Date</b><br/>
            <input type="date"  id="date" value={this.state.from_date}
              style={{width: '100%', height: 35 }} onChange={this.handleChange('from_date')} />
          </div>
          <div style={{marginLeft: '1%'}}>
            <b>To Date</b><br/>
            <input type="date" id="date" value={this.state.to_date}
              style={{width: '100%', height: 35 }} onChange={this.handleChange('to_date')} />
          </div>
          <div style={{marginBottom: '0.5%', marginLeft: '1%'}}>
            <br/>
            <Input placeholder="Search Customer Or Voucher..." onChange={this.handleChange('search')} value={this.state.search}  focus />
          </div>
          <div style={{marginLeft: '1%'}}>
            <br/>
            <Button primary onClick={this.search.bind(this)}>Search</Button>
          </div>
          <div style={{marginLeft: '1%'}}>
            <br/>
            <Button primary onClick={this.export.bind(this)} style={{ display: this.props.display }}>Export</Button>
            <Button primary onClick={this.exportinvoice.bind(this)} style={{ display: this.props.display1 }}>Export</Button>
          </div>
          <div style={{marginLeft: '1%'}}>
            <br/>
            <CancelledInvoice selectedBranch={this.state.selectedBranch} />
          </div>
          { this.props.display != "none" ?
            (
              <div style={{marginLeft: 5, display: 'flex', marginTop: '2.5%'}}>
                <div style={{width: 30, height: 20, background: '#FFDAD2', borderColor: 'black', borderWidth: 1, borderStyle: 'solid'}}></div>
                <div style={{marginLeft: 2}}>Cancelled Invoice</div>
              </div>
            ):
            ""
          }
          <div style={{marginLeft: '1%', marginTop: 'auto', marginBottom: 'auto', fontWeight: 'bold', fontSize: 18, color: '#3E71A4'}}>
            <br/>
              {'Rs.'+this.makeDecimalPoint(this.convertIntoNumbers(this.state.amount))}
          </div>
        </div>
        <div>
          { this.state.quotationDetails.length > 0 ?
            (
              <table id='table' width='100%'>
                <tr>
                  <th id="tableheader"><center>#</center></th>
                  <th id="tableheader"><center>Voucher</center></th>
                  <th id="tableheader"><center>Customer</center></th>
                  <th id="tableheader"><center>Delivery Details</center></th>
                  <th id="tableheader" style={{display: this.props.display1}}><center>Sales Type</center></th>
                  <th id="tableheader" style={{display: this.props.display1}}>Invoice Date<center></center></th>
                  <th id="tableheader">Generate Date</th>
                  <th id="tableheader" style={{display: this.props.display1}}>Point(s)</th>
                  <th id="tableheader">Items</th>
                  <th id="tableheader"><center>Amount</center></th>
                  <th id="tableheader" style={{display: this.props.display1}}><center>DMS Invoice No.</center></th>
                  <th id="tableheader" style={{display: this.props.display1}}><center>DMS Invoice Date</center></th>
                  <th id="tableheader" style={{display: this.props.display1}}><center>DMS Invoice value</center></th>
                  <th id="tableheader" style={{display: this.props.display1}}><center>Diff. Amount</center></th>
                  <th id="tableheader" style={{display: this.props.display1}}><center>Remarks</center></th>
                  <th id="tableheader">View</th>
                  <th id="tableheader" style={{display: this.props.display}}><center>Assign To<br/> Another Branch</center></th>
                  <th id="tableheader" style={{display: this.props.display}}><center>Generate<br/> Invoice</center></th>
                  <th id="tableheader" style={{display: this.props.display1}}><center>Json</center></th>
                  <th id="tableheader" style={{display: this.props.cancelcontol}}>Cancel<center></center></th>
                </tr>
                  { this.state.quotationDetails.map((z) => {
                        let from_date = this.state.from_date;
                        let to_date = this.state.to_date;
                        let date = z.timestamp;
                        let invoiceDate = z.invoice_date;
                        let total = z.totalprice;
                        try {
                          total = Number(total);
                          total = total.toFixed(2);
                          total = Number(total);
                          date = date.split(' ')[0];
                          invoiceDate= invoiceDate.split(' ')[0];
                        } catch (e) {

                        }
                        totals = totals + total;
                        return (
                          <tr style={{backgroundColor: z.cancelledinvoice == 1 ? "#FFDAD2" : "white"}}>
                              <td><center>{((this.state.pageNumber - 1) * 100) + i++}</center></td>
                              <td><u><a href={Server()+"pdf/placeorderpdf2.php?quotationId="+z.id+"&customerId="+z.customerId+"&bankId=0"} target="_blank">{z.voucher}</a></u></td>
                              <td><CustomerDetails type={'quotation'} customerId={z.customerId} customerName={z.customername} /></td>
                              <td style={{cursor: 'pointer'}} onClick={ () => { this.setState({ deliveryMasterId: z.masterId, openDeliveryDialog: true }) }}><center style={{color: 'blue'}}><u>Delivery Details</u></center></td>
                              <td style={{display: this.props.display1}}>
                                <SalesType menuPermission={this.props.menuPermission} salesType={z.sales_type} updateData={ (type, value) => { this.setState({ [type]: value }) } } id={z.id} quotationDetails={this.state.quotationDetails} />
                              </td>
                              <td style={{display: this.props.display1}}><center>{invoiceDate}</center></td>
                              <td><center>{date}</center></td>
                              <td style={{display: this.props.display1}}>
                                <center>
                                  {Number(z.points).toFixed(2)}
                                </center>
                              </td>
                              <td><center>{z.totalstocks}</center></td>
                              <td style={{textAlign: 'right', fontWeight: 'bold'}}
                                  onClick={this.viewTax.bind(this, z.id, total)}>
                                  ₹ {total}
                              </td>
                              <td onClick={ () => { this.setState({ dmsItem: z, dmsEditDialog: true }) }} 
                                style={{display: this.props.display1}}>
                                <center>
                                  {z.dms_invoice_no}
                                </center>
                              </td>
                              <td onClick={ () => { this.setState({ dmsItem: z, dmsEditDialog: true  }) }} 
                                style={{display: this.props.display1}}>
                                <center>{z.dms_invoice_date}</center>
                              </td>
                              <td onClick={ () => { this.setState({ dmsItem: z, dmsEditDialog: true  }) }} 
                                style={{display: this.props.display1}}>
                                <center>
                                  {z.dms_invoice_value}
                                </center>
                              </td>
                              <td onClick={ () => { this.setState({ dmsItem: z, dmsEditDialog: true  }) }} 
                                style={{display: this.props.display1}}>
                                <div style={{textAlign: 'right', fontWeight: 'bold'}}>
                                  {MakeDecimalPoint(this.diffValue(total, z.dms_invoice_value))}
                                </div>
                              </td>
                              <td onClick={ () => { this.setState({ dmsItem: z, dmsEditDialog: true  }) }} 
                                style={{display: this.props.display1}}>
                                <center>
                                  {z.remarks}
                                </center>
                              </td>
                              <td id='pointer'>
                                <center>
                                  <View branchId={z.branchId} customerId={z.customerId} quotationDetails={this.state.quotationDetails}
                                  viewId={z.id} handleClose={this.handleClose.bind(this)} from_date={this.state.from_date} to_date={this.state.to_date}
                                  execeptedDate={z.execeptedDate} masterId={z.masterId}
                                  type={this.props.type} menus={this.props.menus} orderDetails={this.state.orderDetails} />
                                </center>
                              </td>
                              <td style={{display: this.props.display}}>
                                <AssignBranch menuPermission={this.props.menuPermission} id={z.id} branch={z.branchId} getQuotation={this.getQuotation1.bind(this)} />
                                </td>
                              <td id='pointer' style={{display: this.props.display}}>
                              <center>
                              <Editplaceorder menuPermission={this.props.menuPermission} names={'hi'} customerTCS={z.tcs} getQuotation={this.getQuotation1.bind(this)} customerpoints={z.customerpoints}
                              customerId={z.customerId} masterId={z.masterId} quotationId={z.id} />
                              </center></td>
                              <td onClick={ () => this.downloadJson(z.id)} 
                                style={{display: this.props.display1}}>
                                <center><Icon style={{color: '#4757F8'}} name='file' /></center>
                              </td>
                              <td id="pointer" onClick={this.cancel.bind(this, z.masterId, z.invoice, z.id, z.voucher, z.creditstocks)} style={{display: this.props.cancelcontol}}><center>No</center></td>
                          </tr>
                        );
                    })
                  }
              </table>
            ) :
            (
              <div>
              </div>
            )
          }
        </div>
        <div align="right">
        { this.state.totalPages ?
          (
            <Pagination activePage={this.state.pageNumber} boundaryRange={this.state.boundaryRange}
              onPageChange={this.handlePaginationChange} siblingRange={this.state.siblingRange}
              totalPages={this.state.totalPages} ellipsisItem={this.state.showEllipsis ? undefined : null}
              prevItem={this.state.showPreviousAndNextNav ? undefined : null}
              nextItem={this.state.showPreviousAndNextNav ? undefined : null}
            />
          ):''
        }
        </div>


        <Dialog fullWidth={this.state.fullWidth}
            maxWidth={this.state.maxWidth}  open={this.state.dmsEditDialog}
            onClose={ () => { this.setState({ dmsEditDialog: false }) }} aria-labelledby="max-width-dialog-title">
            <DialogTitle id="max-width-dialog-title">DMS VALUES</DialogTitle>
            <DialogContent>
              <DmsValue menuPermission={this.props.menuPermission} refresh={this.getQuotation1.bind(this)} close={() => { this.setState({ dmsEditDialog: false }) }} item={this.state.dmsItem} />
            </DialogContent>
          </Dialog>




        <React.Fragment>
          <Dialog fullWidth={this.state.fullWidth}
            maxWidth={this.state.maxWidth}  open={this.state.viewTaxSystem}
            onClose={this.handleClose.bind(this)} aria-labelledby="max-width-dialog-title">
            <DialogTitle id="max-width-dialog-title">Tax System</DialogTitle>
            <DialogContent>
            <Tax branchState={false}
                 purchaseState={false} data={this.state.taxs}
                 price={this.state.totalPrices} from={'purchasetaxdetails'} />
             </DialogContent>
          </Dialog>
        </React.Fragment>
        <React.Fragment>
          <Dialog fullWidth={this.state.fullWidth}
            maxWidth={this.state.maxWidth1}  open={this.state.invoicePoint}
            onClose={this.handleClose.bind(this)} aria-labelledby="max-width-dialog-title">
            <DialogTitle id="max-width-dialog-title">Point</DialogTitle>
            <DialogContent>
              <Grid>
                <Grid.Column mobile={8} tablet={8} computer={8}>
                  Reward Point<br/>
                  <Input type="number" value={this.state.points} placeholder='Point'
                  onChange={this.handleChange('points')} id='points' />
                </Grid.Column>
                <Grid.Column mobile={8} tablet={8} computer={8}>
                  Redeem Point (Available: {this.state.availablepoints})<br/>
                  <Input type="number" value={this.state.customerpoints} placeholder='Point'
                  onChange={this.handleChange('redeempoints')} id='redeempoints' />
                </Grid.Column>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.generateInvoice.bind(this)}>Submit</Button>
            </DialogActions>
          </Dialog>
        </React.Fragment>
        <React.Fragment>
          <Dialog fullWidth={this.state.fullWidth}
            maxWidth={this.state.maxWidth1}  open={this.state.voucher}
            onClose={this.handleClose.bind(this)} aria-labelledby="max-width-dialog-title">
            <DialogTitle id="max-width-dialog-title">Voucher</DialogTitle>
            <DialogContent>
              <Input fluid value={this.state.voucherValue} onChange={this.handleChange('voucherValue')}  />
              <br/>
              <center>
              <Button onClick={ () => { this.setState({ voucher: false }) }}>Close</Button>
              <Button onClick={this.submit.bind(this)}>Submit</Button>
              </center>
             </DialogContent>
          </Dialog>
        </React.Fragment>
        
      </div>
    );
  }
}

export default Customer;
